import { Newspaper, ArrowRight, FileText, Briefcase, Heart, Leaf, GraduationCap, Landmark, Shield } from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import { ink } from '../../lib/utils';

const CAT_CONFIG = {
  'Empleo': { icon: Briefcase, color: '#3B82F6' },
  'Subvenciones y Ayudas': { icon: Heart, color: '#EC4899' },
  'Medio Ambiente': { icon: Leaf, color: '#10B981' },
  'Educación': { icon: GraduationCap, color: '#8B5CF6' },
  'Cultura': { icon: Landmark, color: '#F59E0B' },
  'Sanidad': { icon: Shield, color: '#EF4444' },
  'Igualdad': { icon: Heart, color: '#EC4899' },
  'Urbanismo': { icon: Landmark, color: '#6366F1' },
};

const DEFAULT_CONFIG = { icon: FileText, color: '#64748B' };

export function BoletinWidget({ bulletins, navigate }) {
  const relevant = (bulletins || []).filter(b => b.simplificado || b.titulo).slice(0, 4);
  if (relevant.length === 0) return null;

  return (
    <div data-testid="boletin-widget">
      <div className="space-y-1.5">
        {relevant.map((b, i) => {
          const cat = (b.categorias || [])[0] || '';
          const cfg = CAT_CONFIG[cat] || DEFAULT_CONFIG;
          const Icon = cfg.icon;
          const title = b.simplificado || b.titulo || '';

          return (
            <button key={b.id || i} onClick={() => navigate(`/boletines${cat ? `?filtro=${encodeURIComponent(cat.toLowerCase())}` : ''}`)}
              className="w-full flex items-start gap-2.5 p-2 rounded-xl hover:bg-slate-50 transition-colors text-left group">
              <div className="w-8 h-8 sm:w-9 sm:h-9 shrink-0 rounded-lg flex items-center justify-center mt-0.5" style={{ backgroundColor: `${cfg.color}12` }}>
                <Icon size={14} style={{ color: ink(cfg.color) }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[11px] sm:text-xs font-bold text-slate-800 leading-snug line-clamp-2 group-hover:text-torre-teal transition-colors">{title}</p>
                <div className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 mt-1">
                  {cat && (
                    <Badge className="text-[11px] sm:text-[11px] rounded-full px-1.5 py-0" style={{ backgroundColor: `${cfg.color}15`, color: ink(cfg.color), borderColor: `${cfg.color}30` }}>
                      {cat}
                    </Badge>
                  )}
                  <span className="text-[11px] text-slate-400">{b.fuente}</span>
                  {b.fecha && <span className="text-[11px] text-slate-400">· {new Date(b.fecha + 'T00:00:00').toLocaleDateString('es-ES', { day: 'numeric', month: 'short', timeZone: 'Europe/Madrid' })}</span>}
                </div>
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-slate-400 mt-2">Ayuntamiento · BOC</p>
    </div>
  );
}
